import {Component, Input, ViewChild} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

import {dateFromStringServerFormat, dateToString} from "../../../../shared";

import { Rol} from "../../../../core";
import {Mensaje} from "../../../index";
import {MensajeTableParams, MensajeTableValue} from "../../../models/mensaje";
import { personaName } from 'src/app/chacra-core/helpers/persona.helper';


@Component({
  selector: 'app-mensajes-table',
  templateUrl: './mensaje-table.component.html',
  styleUrls: ['./mensaje-table.component.scss']
})
export class MensajeTableComponent {
  @ViewChild(MatTable, {static: true}) table: MatTable<any>;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  // aux
  displayedColumns: string[] = [
    'reply',
    'viewAttachment',
    'fecha',
    'autor',
    'contenido'
  ];
  dataSource: MatTableDataSource<MensajeTableValue> = new MatTableDataSource(
    []
  );

  constructor() {
  }

  // input
  private _params: MensajeTableParams = null;

  get params(): MensajeTableParams {
    return this._params;
  }

  @Input()
  set params(params: MensajeTableParams) {
    this._params = params;
    this.update();
  }

  // datasource
  update() {
    this.dataSource.data = this.params.mensajes.map(m => ({
      fecha: dateToString(dateFromStringServerFormat(m.mensajeFecha)),
      autor: this.getAutorName(m.personaId),
      contenido: m.mensajeContenido,
      mensaje: m
    }));
  }

  getAutorName(personaId: string){
   const autor = this.params.personas.find(p => p.personaId === personaId);
   let name = '';
   if(autor){
    name = personaName(autor);
   }
   return name;
  }

  markMensaje(m: Mensaje) {
  }

  viewAttachment(m: Mensaje) {
  }

  canActionated() {
    return this.params && this.params.sources &&
      this.params.sources.rolId === Rol.USUARIO_LIBRE;
  }
}
